/* 12 dermatologists: one separator height on every card (Zeus, 21 Oct). Every quote gets the tallest quote's height as
   min-height (--pp-derm-quote-h), so the rule under it sits at the same offset in all cards, at every width. Without JS
   the quotes keep their own heights. Recomputed on resize and once the webfont has loaded. */
(function () {
  'use strict';
  var root = document.querySelector('.pp-derm__cards');
  if (!root) return;
  var quotes = Array.prototype.slice.call(root.querySelectorAll('.pp-derm__quote'));
  if (quotes.length < 2) return;

  function sync() {
    root.style.removeProperty('--pp-derm-quote-h');
    var max = 0;
    quotes.forEach(function (q) { max = Math.max(max, q.getBoundingClientRect().height); });
    root.style.setProperty('--pp-derm-quote-h', max + 'px');
  }

  var frame = 0;
  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(function () { frame = 0; sync(); });
  }

  sync();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(root);
  else window.addEventListener('resize', schedule);
})();
